// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__fjQ79","tab":"ProcedureTabs_tab__3YyYl"};